export default __webpack_public_path__ + "static/media/vip9_left.94be7fc5.webp";